export const TXTCLI_Incorrect_Information_Entered = {
  "id": "TXTCLI_Incorrect_Information_Entered",
  "defaultMessage": "Incorrect Information Entered"
} as const;

export const TXTCLI_Your_name_and_date_of_birth_is_ELL_1 = {
  "id": "TXTCLI_Your_name_and_date_of_birth_is_ELL_1",
  "defaultMessage": "Your name and date of birth is not permitted in your password."
} as const;

export const TXTWCL_At_least_one_capital_letter_XA_ELL = {
  "id": "TXTWCL_At_least_one_capital_letter_XA_ELL",
  "defaultMessage": "At least one capital letter (A-Z)"
} as const;

export const TXTWCL_At_least_one_symbol_XeXgX_XX = {
  "id": "TXTWCL_At_least_one_symbol_XeXgX_XX",
  "defaultMessage": "At least one symbol (e.g. !@#$)"
} as const;

export const TXTWCL_Must_contain_at_least_3_of_the_ELL = {
  "id": "TXTWCL_Must_contain_at_least_3_of_the_ELL",
  "defaultMessage": "Must contain at least 3 of the following: (0-9), (a-z), (A-Z), symbol (for example !@#$)"
} as const;

export const TXTWCL_Must_contain_at_least_one_digi_ELL = {
  "id": "TXTWCL_Must_contain_at_least_one_digi_ELL",
  "defaultMessage": "Must contain at least one digit (0-9)"
} as const;

export const TXTWCL_The_address_you_have_entered_i_ELL_1 = {
  "id": "TXTWCL_The_address_you_have_entered_i_ELL_1",
  "flags": [
    "TRACK"
  ],
  "defaultMessage": "The address you have entered is invalid."
} as const;